import React, { Component } from 'react';
import { FormGroup, Label, Form} from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';

export class AddComments extends Component {
  displayName = AddComments.name

  constructor(props) {
    super(props);

    this.state = {
      fio: '',
      comment: '',
      isPostComment: false
    }

    this.addComment = this.addComment.bind(this);
  }

  addComment(e) {
    e.preventDefault();

    var data = new FormData();

    data.append('nameAuthor', this.state.fio);
    data.append('commentText', this.state.comment);

    const requestOptions = {
        method: 'POST',
        body: data
    };

    fetch('api/DataforDB/AddComment', requestOptions)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response;
        })
        .then(() => {
          this.setState({isPostComment: true})
        })
        .catch(error => toast.error('Произошла ошибка при добавлении комментария.'));
  }

  render() {
    return (
      <div>
        <ToastContainer/>
        <h1>Добавление отзыва</h1>
        {this.state.isPostComment && <FormGroup className='alert alert-primary'>Спасибо за ваш отзыв! Он будет опубликован после проверки администратором</FormGroup>}
        {!this.state.isPostComment && <Form onSubmit={this.addComment}>
          <FormGroup>
              <Label>ФИО</Label>
              <input
                  className='form-control'
                  type='text'
                  placeholder='Введите ФИО'
                  onChange={e => {
                      const value = e.target.value;
                      this.setState({fio: value});
                  }}
                  value={this.state.fio}
              />
          </FormGroup>
          <FormGroup>
              <Label>Комментарий</Label>
              <textarea
                  className='form-control'
                  type='text'
                  onChange={e => {
                      const value = e.target.value;
                      this.setState({comment: value});
                  }}
                  value={this.state.comment}
                  placeholder={'Введите комментарий'}
              />
          </FormGroup>
          <FormGroup>
              <button className='btn btn-primary' type='submit'>Добавить</button>
          </FormGroup>
        </Form>}
      </div>
    );
  }
}
